import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.aniEGsapB1} aniEGsapB1`}>
            <div className="msg-title">{t('smart_home_panel.twelve_title')}</div>
            <div className="msg-line1">
                {t('smart_home_panel.twelve_subtitle_pc1')}
                <div></div>
                {t('smart_home_panel.twelve_subtitle_pc2')}
            </div>
        </div>
    );
}
